// src/ProcedureList.js
import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";
import { useNavigate } from "react-router-dom";
import { useOrganization } from "./contexts/OrganizationContext";
import { OrganizationService } from "./services/organizationService";

function ProcedureList() {
  const { currentOrganization } = useOrganization();
  const [procedures, setProcedures] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedDept, setSelectedDept] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProcedures = async () => {
      if (!currentOrganization?.id) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        // 組織配下のproceduresとdepartmentsを取得
        const procCollection = OrganizationService.getOrgCollection(
          currentOrganization.id,
          "procedures"
        );
        const deptCollection = OrganizationService.getOrgCollection(
          currentOrganization.id,
          "departments"
        );

        const [procSnapshot, deptSnapshot] = await Promise.all([
          getDocs(procCollection),
          getDocs(deptCollection)
        ]);

        const deptData = deptSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const procData = procSnapshot.docs.map((doc) => {
          const data = doc.data();
          // departmentId から department 名を取得
          const dept = deptData.find(d => d.id === data.departmentId);
          return {
            id: doc.id,
            ...data,
            department: dept?.name || data.department || "不明"
          };
        });

        setProcedures(procData);
        setDepartments(deptData);
      } catch (error) {
        console.error("術式データの取得に失敗しました:", error);
        alert("術式データの取得に失敗しました: " + error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProcedures();
  }, [currentOrganization]);

  // 診療科名のユニークなリストを取得
  const departmentNames = Array.from(
    new Set(procedures.map((p) => p.department))
  ).sort();

  // 選択された診療科でフィルタリング
  const filtered = selectedDept
    ? procedures.filter((p) => p.department === selectedDept)
    : procedures;

  // 組織が選択されていない場合
  if (!currentOrganization?.id) {
    return (
      <div style={{ padding: "1rem", fontFamily: "sans-serif" }}>
        <h1>術式手順書一覧</h1>
        <div style={{ 
          textAlign: "center", 
          padding: "2rem", 
          color: "#666",
          fontSize: "1.1rem"
        }}>
          組織を選択してください
        </div>
      </div>
    );
  }

  // ローディング中
  if (loading) {
    return (
      <div style={{ padding: "1rem", fontFamily: "sans-serif" }}>
        <h1>術式手順書一覧</h1>
        <div style={{ 
          textAlign: "center", 
          padding: "2rem", 
          color: "#666",
          fontSize: "1.1rem"
        }}>
          読み込み中...
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: "1rem", fontFamily: "sans-serif" }}>
      <h1>術式手順書一覧</h1>

      <label style={{ marginBottom: "1rem", display: "block" }}>
        診療科で絞り込み：
        <select
          value={selectedDept}
          onChange={(e) => setSelectedDept(e.target.value)}
          style={{ 
            marginLeft: "1rem",
            padding: "0.5rem",
            borderRadius: "4px",
            border: "1px solid #ccc"
          }}
        >
          <option value="">すべて</option>
          {departmentNames.map((dept, index) => (
            <option key={`dept_${dept}_${index}`} value={dept}>
              {dept}
            </option>
          ))}
        </select>
      </label>

      <ul style={{ listStyle: "none", paddingLeft: 0 }}>
        {filtered.map((proc, index) => (
          <li
            key={`procedure_${proc.id}_${index}`}
            onClick={() => navigate(`/procedures/${proc.id}`)}
            style={{
              margin: "0.5rem 0",
              padding: "0.8rem",
              border: "1px solid #ddd",
              borderRadius: "5px",
              cursor: "pointer",
              backgroundColor: "#f9f9f9",
              transition: "background-color 0.2s"
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#e9ecef"}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#f9f9f9"}
          >
            <strong>{proc.name}</strong>（{proc.department}）
          </li>
        ))}
      </ul>

      {filtered.length === 0 && procedures.length > 0 && (
        <div style={{ 
          textAlign: "center", 
          padding: "2rem", 
          color: "#666",
          fontSize: "1.1rem"
        }}>
          選択された診療科の手順書が見つかりませんでした。
        </div>
      )}

      {procedures.length === 0 && (
        <div style={{ 
          textAlign: "center", 
          padding: "2rem", 
          color: "#666",
          fontSize: "1.1rem"
        }}>
          手順書が登録されていません。
        </div>
      )}
    </div>
  );
}

export default ProcedureList;